import CompleteRegisterAuth from 'modules/auth/CompleteRegistration'

const CompleteRegistration = () => {
  return <CompleteRegisterAuth />
};

export default CompleteRegistration;